import { PaginationParams } from "@shared/models/common";
import { CatDoc } from "@shared/models/cat.model";

export class AssetImageField {
    imageAssetFieldId!: number;
    imageAssetId!: number;
    fieldName!: string;
    fieldType!: string;
    fieldText!: string;
}

export class AssetCatImage {
    catVersionId!: number;
    catImageId!: number;
    documentId!: number | null;
    documentName!: string | null;
    versionId!: number | null;
    fileName!: string | null;
    pageNum!: number | null;
    x1!: number | null;
    y1!: number | null;
    x2!: number | null;
    y2!: number | null;
    pagesCnt!: number | null;
}

export class AssetImageViewModel {
    imageAssetId!: number;
    catId!: number;
    s3Key!: string;
    encryptKey!: string;
    s3Url?: string;
    figureType!: string;
    figureSubType!: string | null;
    figureCategory!: string | null;
    imageAssetFields!: AssetImageField[];
    catImages!: AssetCatImage[];
    docs!: CatDoc[];
    metadata!: AssetDocMetadata[];
}

export class AssetDocMetadata {
    fieldLabel!: string;
    fieldName!: string;
    fieldValues!: string[];
}

export class AssetImagesSearchParams extends PaginationParams {
    constructor() { super(); }
}

export class AssetImagesInfo {
    imageAssets!: AssetImageViewModel[];
    stats!: AssetImagesStats;
}

export class AssetImagesStats {
    totalCount!: number;
}

export class AssetImagesInfoDto {
    totalCount!: number;
    fromRec!: number;
    toRec!: number;
    image_assets!: AssetImageDto[];
}

export class AssetImageDto {
    image_asset_id!: number;
    cat_id!: number;
    s3_key!: string;
    encrypt_key!: string;
    figure_type!: string;
    figure_sub_type!: string | null;
    figure_category!: string | null;
    image_asset_fields!: AssetImageFieldDto[];
    cat_images!: AssetCatImageDto[];
}

export class AssetImageFieldDto {
    image_asset_field_id!: number;
    image_asset_id!: number;
    field_name!: string;
    field_type!: string;
    field_text!: string;
}

export class AssetCatImageDto {
    cat_version_id!: number;
    cat_image_id!: number;
    document_id!: number | null;
    document_name!: string | null;
    version_id!: number | null;
    file_name!: string | null;
    page_num!: number | null;
    x1!: number | null;
    y1!: number | null;
    x2!: number | null;
    y2!: number | null;
    pages_cnt!: number | null;
}
